import { COMEIN_URL } from '@/utils/host';
import { COMPANY_STORE_ID, COMPANY_STOCK_MARKET, COMPANY_STOCK_CODE, COMPANY_FULL_CODE } from '@/const/host';

export const common = {
	// 通用接口
	phpUrl: COMEIN_URL + '/index.php'
};

export const enterprise = {
	getBaseInfo: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}`,
	getFinancialStatement: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/financial-statement`,
	getProfitStatement: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/profit-statement`,
	getBalanceSheet: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/balance-sheet/sum`,
	getCashFlowStatement: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/cash-flow-statement`,
	//总营收按类型分类 http://yapi.comein.cn/project/56/interface/api/52666
	getStockRevenue: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/revenue`,
	//queryPeriod http://yapi.comein.cn/project/56/interface/api/52736
	getStockRevenuePerio: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/revenue/period`,
	getAnnouncements: `${COMEIN_URL}/irmcenter/v2/anonymous/irstore/${COMPANY_STORE_ID}/announcements`,
	//获取公告分类及时间 http://yapi.comein.cn/project/56/interface/api/52742
	getClassifications: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/announcement/year/classifications`,
	getStockQuote: `${COMEIN_URL}/irmcenter/anonymous/irstore/market/${COMPANY_STOCK_MARKET}/code/${COMPANY_STOCK_CODE}/quote`,
	getKLineData: t => `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/candlestick-chart/${t}`,
	getNewsList: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}/news`,
	getQuarterPerf: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}/quarter/performance-list`,
	getCustomModuleContent: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}/moduleContent`,
	getRevenueList: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/revenue-list`,
	news: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}/news`,
	getNewsYear: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}/news/year`,
	newsDetail: newsId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}/news/${newsId}`,
	createLeaveWord: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}/leaveWord`,

	getAnalystData: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}/analyst`, // 支持分页
	getAnalystDataSide: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}/analyst/side`, // 不支持分页

	reportList: `${COMEIN_URL}/irmcenter/anonymous/irstore/report/list`,
	postReportYear: `${COMEIN_URL}/irmcenter/anonymous/irstore/report/year-list`,

	postModuleYear: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_STORE_ID}/moduleContent/year`,

	getStockDividendPlan: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/dividend-plan`,
	getStockMarginFunds: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/margin-funds`,
	getStockNorthSouthFunds: `${COMEIN_URL}/irmcenter/anonymous/irstore/${COMPANY_FULL_CODE}/stock/north-south-funds`
};
